<template>
  <div class="main">
      <img alt="Vue logo" src="./assets/smplogo.png">
      <br />
      <span style="font-size: 26px; margin: 20px">Coming soon...</span>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {

  }
}
</script>

<style>
.main {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
